import { InjectionToken } from '@angular/core';
import { BaseEnvironmentVariables } from '@gcm/gcm-ui-angular';
import { AppTileConfig } from './application.model';

export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  landingAudience: string;
}


export interface AppConfig extends BaseEnvironmentVariables {
  appName: string;
  auth0: Auth0Config;
  enableDarkMode: boolean;
  enableAutoRedirect: boolean;
  enableAutoRedirectGcmUsers: boolean;
  loggingTargets: string[];
  applications: AppTileConfig[];
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');
